import { render } from "./S213807.vue?vue&type=template&id=10054268"
const script = {}
script.render = render

export default script